// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const CustomerFailed = t.struct({
    ckcCustomerFailed: t.Boolean
}, 'CustomerFailed');

export const getDefaultState = () =>
    new CustomerFailed({
        ckcCustomerFailed: false
    });

export default CustomerFailed;



// WEBPACK FOOTER //
// ./src/shared/state/customer-failed.js